import React, { Component } from "react";
import firebase from "firebase/app";
import PropTypes from "prop-types";

import Page from "../shared/Page";
import ChangeHistory from "../shared/ChangeHistory";
import Phone from "../ui/Phone";
import "firebase/auth";

class DashboardPage extends Component {
	state = {
		data: {
			labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
			datasets: [
				{
					label: "# of Votes",
					data: [3, 4, 3.5, 5, 9, 9.5],
					backgroundColor: [
						"rgba(255, 99, 132, 0.0)",
						"rgba(54, 162, 235, 0.2)",
						"rgba(255, 206, 86, 0.2)",
						"rgba(75, 192, 192, 0.2)",
						"rgba(153, 102, 255, 0.2)",
						"rgba(255, 159, 64, 0.2)",
					],
					borderColor: [
						"rgba(255,99,132,1)",
						"rgba(54, 162, 235, 1)",
						"rgba(255, 206, 86, 1)",
						"rgba(75, 192, 192, 1)",
						"rgba(153, 102, 255, 1)",
						"rgba(255, 159, 64, 1)",
					],
					borderWidth: 1,
				},
			],
		},
		token: null,
		options: {
			showLines: false,
		},
	};
	componentDidMount = () => {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(data => this.setState({ token: data }));
	};

	render() {
		const { match } = this.props;
		const { appKey } = match.params;
		return (
			<Page title="Dashboard">
				<h1 className="page-title">{"Welcome To Your App"}</h1>
				<div className="ta-center">
					<ChangeHistory id={appKey} entity="apps" />
					<Phone showHistory={true} itemKey="helloworld" />
				</div>
			</Page>
		);
	}
}
DashboardPage.propTypes = {
	match: PropTypes.object,
};
export default DashboardPage;
